// import store from '@/store'

import columns from './tableConfig'
import { searchItems } from './searchFormConfig'
import { GetAllUnInvoiceOrders } from '../../../../../api/orderMana'
let searchCache = {}
import ApplyInvoiceModal from '../InvoiceCreate/index'
import { CreateInvoice } from '../../../../../api/invoiceMana'

// const enumsData = store.state.enumsStore.enumsData
// console.log(enumsData)

const payTypes = {
  1:{
    'code': 1,
    'name': '微信扫码'
  },
  2: {
    'code': 2,
    'name': '支付宝扫码'
  }
}

const payStates = {
  1: {
    'code': 1,
    'name':'未支付'
  }
  ,
  2: {
    'code':2,
    'name':'支付成功'
  }
  ,
  3: {
    'code':3,
    'name': '部分退款'
  }
  ,
  4: {
    'code': 4,
    'name':'全额退款'
  }
  ,
  5: {
    'code':5,
    'name': '关闭支付'
  }
  ,
  6: {
    'code': 6,
    'name':'超时关闭'
  }
}

export default {
  name: 'OrdersIndex',
  components: {
    ApplyInvoiceModal
  },
  data() {
    return {
      searchItems,
      searching: false,
      columns,
      payStates,
      payTypes,
      data: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      states: {
        0: '启用',
        1: '禁用'
      },
      showEditAppModal: false,
      showAddNumberModal: false,
      showDetailDrawer: false,
      targetApp: null,
      targetTerminal: null,

      selectedRowKeys: [], // 列表多选钩中项的Id数组
      selectedRowItems: [], // 列表多选钩中项的数组
      showCreateModal: false,
      createLoading: false,
    }
  },
  watch: {
    // '$route.params.clientId': function(id) {
    //   if (id) {
    //     this.$refs.searchForm.resetFields()
    //     this.$refs.searchForm.setFieldsValue({ customerId: id })
    //     this.$refs.searchForm.handlerSearch()
    //
    //     // 清理页面跳转时在路由上传递的搜索条件
    //     this.$route.params.clientId = undefined
    //   }
    // }
  },
  created() {
    this.$nextTick(async () => {
      this.selectedRowItems = []
      this.selectedRowKeys = []
      this.getAllOrders()
    })
  },

  methods: {
    // 查询应用
    async getAllOrders(page = 1, searchData) {
      try {
        this.loading = true
        // 确定搜索条件
        searchData = searchData || searchCache
        // 缓存搜索条件
        searchCache = searchData
        let {
          transactionNo,
          dateTimeRange
        } = searchData

        let updatedAtFrom, updatedAtTo
        if (dateTimeRange && dateTimeRange.length) {
          updatedAtFrom = dateTimeRange[0].format('YYYY-MM-DD HH:mm:ss')
          updatedAtTo = dateTimeRange[1].format('YYYY-MM-DD HH:mm:ss')
        }

        await GetAllUnInvoiceOrders({
          updatedAtFrom,
          updatedAtTo,
          page,
          perPage: this.pagination.pageSize
        }).then(res => {
          let data = res.data.collection
          this.data = data.map(app => Object.assign(app, { key: app.id }))
          this.pagination.current = page
          this.pagination.total = res.data.size
        })
      } catch (error) {
      }
      this.loading = this.searching = false
    },
    // 翻页
    handlePageTurn(pagination, filters, sorter) {
      const { current } = pagination
      this.getAllOrders(current)
    },
    // 打开应用详情抽屉弹窗
    handlerDetailDrawer(data) {
      this.targetTerminal = data
      this.showDetailDrawer = true
    },
    // 关闭应用详情抽屉弹窗
    handlerCloseDetailDrawer() {
      this.showDetailDrawer = false
      setTimeout(() => {
        this.targetTerminal = null
      }, 500)
    },
    // table项勾选
    handleTableItemSelected(rowKeys, rowItems) {
      this.selectedRowKeys = rowKeys;
      this.selectedRowItems = rowItems;
    },
    handleApplyInvoice(){
      this.showCreateModal = true
    },
    handleInvoiceCreateOk(data){
      this.createLoading = true
      let param = Object.assign({orderIds: this.selectedRowKeys},data)
      CreateInvoice(param).then(res=>{
        if (res.data.success){
          this.showCreateModal = false
          this.$message.success("发票申请成功")
          this.getAllOrders(1)
        }
        this.createLoading = false
      })
    },
    handleInvoiceCreateCancel(){
      this.showCreateModal = false
    },
  }
}
